module.exports = __webpack_public_path__ + "static/media/mid.6ab94f3c.png";